import * as fabric from 'office-ui-fabric-react';
import React, { FC } from 'react';

const NotFoundPage: FC = () => {
    return (
        <div
            style={{ backgroundColor: fabric.getTheme().palette.themePrimary, minHeight: '30vh', width: '100%', textAlign: 'center' }}
            className="homePage"
            dir="ltr"
        >
            <div className="ms-slideRightIn40" style={{ padding: '80px' }}>
                <fabric.Text
                    style={{ fontSize: '50px', fontWeight: 'lighter', color: 'white', paddingTop: '40px', marginTop: '40px' }}
                    variant="xxLargePlus"
                >
                    Tokio puslapio nėra
                </fabric.Text>
            </div>
        </div>
    );
};

export default NotFoundPage;
